import moment from "moment";
const format = (value, id) => {
  let numeral = require("numeral");

  const typoFormat = {
    0: "0,00",
    1: "0,0.00",
    2: "0,0.[00]",
  };

  return numeral(value).format(typoFormat[id]);
};
const formatMiles = ({value, numDecimal=0}) => {
  const numberF = new Intl.NumberFormat("es-VE", {
    maximumFractionDigits: numDecimal,
    minimumFractionDigits: numDecimal,
  }).format(Number(value));
  return  numberF;
};
const formatFecha = (fecha, id) => {
  moment.locale("es");
  const typoFormat = {
    0: "MMM",
    1: "DD/MM/YY",
  };
  return moment(fecha).format(typoFormat[id]).toUpperCase();
};
const formatMes = (fecha) => {
  moment.locale("es");
  return moment(fecha).format("MMM").toUpperCase();
};
const PorcCol = (total, item) => {
  return (item / total) * 100;
};

const visiblePrecio = ({
  articulo,
  usuario,
  arrcat = [1018],
  arrsubcat = [30, 40],
  arrtipos = ["Maquina"],
}) => {
  const { TipoProd, Categoria, SubCategoria } = articulo;
  const { TipoUsuario } = usuario;
  const validaCat = arrcat.some((element) => element === Categoria);
  const validaSubCat = arrsubcat.some((element) => element === SubCategoria);

  const validaTipoProd = arrtipos.some((element) => element === TipoProd);
  return TipoUsuario !== "U" && validaTipoProd && validaCat && validaSubCat;
};

const redondeo = (num, tipo) => {
  /*
  esta funcion permite redondear hacia cero 
  Las reglas a cero y lejos de cero arreglan la desviación positivos y negativos. 
  Se observa en la tabla del segundo apartado que están equilibradas en positivos y negativos.
  La primera a cero se implementa con la función sgn(n) × ⌈ |n| - 0.5 ⌉, o expresado también como sgn(n) × ceil(abs(n) - 0.5). 
  */
  if (tipo == 1) {
    //redondeo con Math.round()
    return Math.round(num);
  } else if (tipo == 2) {
    //redondeo hacia cero
    return Math.sign(num) * Math.ceil(Math.abs(num) - 0.5);
  }
};
const mesAnnio = (fecha) => {
  var d = new Date();
  var n = d.getMonth();

  if (
    fecha !==
    new Date().toLocaleString("sv", { timeZoneName: "short" }).substr(0, 4)
  )
    return 11;
  else return n;
};
const getMes = (id) => {
  let meses = {
    1: "Ene",
    2: "Feb",
    3: "Mar",
    4: "Abr",
    5: "May",
    6: "Jun",
    7: "Jul",
    8: "Ago",
    9: "Sept",
    10: "Oct",
    11: "Nov",
    12: "Dic",
  };

  return meses[id];
};
export {
  formatMes,
  getMes,
  format,
  redondeo,
  PorcCol,
  mesAnnio,
  formatFecha,
  visiblePrecio,
  formatMiles
};
